var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 228 176.8",
    style: {
      enableBackground: "new 0 0 228 176.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1,92.6c2.1-9.1,9.3-14.4,15.8-19.8c6.5-5.4,15.9-4.2,22.2,2c6.7,6.6,13.3,13.2,19.9,19.9 c6.4,6.4,12.7,12.7,19.1,19.1c0.5,0.5,1.1,1,2.2,2.1c0.6-0.9,0.9-1.8,1.6-2.5c35.8-35.9,71.6-71.7,107.5-107.5 c5.5-5.5,11.9-7.4,19.4-4.7c5.1,1.9,16.2,13.2,18.1,18.2c0.4,1.2,0.8,2.3,1.2,3.5c0,1.6,0,3.3,0,4.9c-1.1,5.6-4.8,9.6-8.7,13.5 c-43.4,43.4-86.8,86.8-130.2,130.2c-2.1,2.1-4.4,3.9-7.5,4.4c-4.3,0.6-7.8-0.9-10.8-3.9c-14.2-14.2-28.4-28.4-42.6-42.6 C22.1,123.3,16,117,9.7,111c-4-3.8-7.6-7.8-8.7-13.5C1,95.9,1,94.2,1,92.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.dd6b2c8c3b9e9830d3e68377bdd41b52.svg";
export { ForwardRef as ReactComponent };